import { useEffect } from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import ReAssessmentFilter from "../../app/re-assessment/ReAssessmentFilter";
import ReAssessmentGrid from "../../app/re-assessment/ReAssessmentGrid";
import ReAssessmentQuickFilterBar from "../../app/re-assessment/ReAssessmentQuickFilterBar";
import ReAssessmentStats from "../../app/re-assessment/ReAssessmentStats";
import AppConfig from "../../core/service/AppConfig";

/**
 * "Rapor Operasyonları → Yeniden Değerlendirme".
 *
 * Tüm liste ve istatistik işi burada; rapor ekranına kolon eklenmedi. Erişim tek yetkiye bağlı
 * (RE_ASSESSMENT_MANAGE) — yönlendirme AppRouter'da da aynı yetkiyle korunuyor.
 */
export default function ReAssessmentPage() {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${t('Re-Assessment')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <DataGridProvider>
            <LayoutWithSider
                fullWidth={true}
                sidebarTitle={t('Re-Assessment Filter')}
                rememberOpen={false}
                sidebarComponent={<ReAssessmentFilter />}
            >
                {/* Hızlı filtreler ve istatistik grid kartının üstünde, her blok ayrı kart; hepsi grid'in UYGULANAN
                    filtresine bakar (sol panelle ortak). İstatistik eskiden ayrı sekmedeydi: filtreyle birlikte
                    görülsün diye listenin yanına alındı. */}
                <ReAssessmentQuickFilterBar />
                <ReAssessmentStats />
                <Card>
                    <ReAssessmentGrid />
                </Card>
            </LayoutWithSider>
        </DataGridProvider>
    )
}
